export default {
  init() {
    // JavaScript to be fired on the home page

    $(".home-filter-submit").on("click", () => {
      let date = $("#filter_date").val();
      let country = $("#filter_country").val();
      let destination = $("#filter_destination").val();
      let type = $("#filter_type").val();

      let url = `/trip-calendar/?date=${date}&country=${country}&destination=${destination}&type=${type}`;
      window.location.href = url;
    });

    $(".home--trip-filter--toggle").on("click", () => {
      $(".home--trip-filter").toggleClass("open");
    });

    $(document).on('gform_confirmation_loaded', function(){

      $('.homepage-banner__content').addClass('form-submitted'); 
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js